import { render } from "./Cpu.vue?vue&type=template&id=50dcaea2"
import script from "./Cpu.vue?vue&type=script&lang=js"
export * from "./Cpu.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__